import { useEffect, useRef } from 'react';
import { initAnalytics, track } from '@/lib/analytics';
import type { SatelliteConfig } from './config';

let satelliteAnalyticsReady = false;

export function ensureSatelliteAnalytics(): void {
  if (satelliteAnalyticsReady) return;
  initAnalytics();
  satelliteAnalyticsReady = true;
}

export function useSatelliteScreenEvent(config: SatelliteConfig): void {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    track(config.screenEvent, {
      host: config.apex,
      tool: config.slug,
      seo_category: 'satellite',
    });
  }, [config]);
}

export function trackSatelliteAction(
  eventName: string,
  config: SatelliteConfig,
  extra?: Record<string, unknown>,
): void {
  track(eventName, {
    host: config.apex,
    tool: config.slug,
    seo_category: 'satellite',
    ...extra,
  });
}
